import { Flex } from '@lego/klik-ui';
import { AppWindowTwo, CloudUploadDownload, DevicesResponsiveWebSite } from '@lego/klik-ui/icons';
import { KpiCard } from '@/components/kpi';
import { useKpiDetails } from '@/hooks/kpi_details';
import { TextHeader } from '../common';
import { Loader } from '../common/Loader';

export const KpiDetails = () => {
  const { data, error, isLoading } = useKpiDetails();
  const dataReady = isLoading || error || !data;
  const kpis = data?.data;

  return (
    <Flex background="white" boxShadow={'md'} flexDirection="column" p={10} rounded={'md'}>
      <TextHeader mb={10} tagLevel="h1" title="Platform Adoption KPI&apos;s" weight="bold" />
      {dataReady ? (
        <Loader />
      ) : (
        <Flex
          flexDirection="row"
          flexWrap="wrap"
          gap={4}
          justifyContent={{ base: 'start', md: 'space-around', sm: 'center' }}
        >
          <KpiCard
            count={kpis?.deviceCount}
            icon={<DevicesResponsiveWebSite boxSize="4rem" />}
            name="Devices"
          />
          <KpiCard
            count={kpis?.applicationCount}
            icon={<AppWindowTwo boxSize="4rem" />}
            name="Applications"
          />
          <KpiCard
            count={kpis?.serviceCount}
            icon={<CloudUploadDownload boxSize="4rem" />}
            name="Store Services"
          />
        </Flex>
      )}
    </Flex>
  );
};
